import React from 'react';
import { useDispatch } from 'react-redux';

import type { MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import { ResponsiveDialog, useQuery, useSettings, useUserData, Utils } from 'app/main/components';
import AddRowsQueryDialog from 'app/main/modules/components/AddRowsQueryDialog';

import DemsRecipientsAddResultDialog from './DemsRecipientsAddResultDialog';

interface DemsRecipientsAddQueryDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	demsUid: string;
	table: string;
	defaultFilters: MiddlewhereFilter[];
	updateRefresh: VoidFunction;
}

export default function DemsRecipientsAddQueryDialog(props: DemsRecipientsAddQueryDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const queryProps = useQuery({ module: props.table });

	const [showResultsDialog, setShowResultsDialog] = React.useState(false);

	const closeDialog = () => {
		queryProps.handleQueryClear();
		setShowResultsDialog(false);
		props.switchOpenDialog();
	};

	const showResults = () => {
		queryProps.handleQueryApply();
		setShowResultsDialog(true);
	};

	const addRows = () => {
		Utils.executeStored({
			action: 'st_dems_recipients_add_multiple',
			dispatch,
			data: {
				derc_dems_uid: props.demsUid,
				derc_user_created_uid: userData.user_uid,
				filters: props.defaultFilters,
				query: queryProps.query
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				closeDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg" scroll="body">
			{!showResultsDialog ? (
				<AddRowsQueryDialog
					title={t(`DEMS_SECTION_ADD_${props.table}_TITLE`)}
					currentTree={queryProps.currentTree}
					queryConfig={queryProps.queryConfig}
					handleQueryChange={queryProps.handleQueryChange}
					showResults={showResults}
					closeDialog={closeDialog}
				/>
			) : (
				<DemsRecipientsAddResultDialog
					defaultFilters={props.defaultFilters}
					defaultQuery={queryProps.query}
					addRows={addRows}
					goBack={() => setShowResultsDialog(false)}
				/>
			)}
		</ResponsiveDialog>
	);
}
